<template>
  <div>
    <datatable
      title="Position Texts"
      @create="createText"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'position-texts',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'content',
          value: 'content'
        }
      ],
      data: [],
      operations: [],
      position_id: this.$route.query.position_id,
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceTexts({
          current_type: 'Position',
          current_resource_id: this.position_id
        })
        .then(response => {
          this.data = response
        })
    },
    createText () {
      this.create({ designator: 'position-texts-form-modal', component_name: 'TextsForm', is_create: true, resource_type: 'Position', resource_id: this.position_id, modal_title: 'Create new Text', company_id: this.company_id, position_status: this.$route.query.position_status })
    },
    editClick (data) {
      this.create({ designator: 'position-texts-form-modal', component_name: 'TextsForm', data: data, resource_type: 'Position', resource_id: this.position_id, modal_title: data.designator, company_id: this.company_id, position_status: this.$route.query.position_status })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
